import { Checkbox } from 'antd';
import {
  FARM_DIAGNOSTICS_DISPLAY_MARKERS_LABEL,
  FARM_DIAGNOSTICS_DISPLAY_OPTIONS_TITLE,
  FARM_DIAGNOSTICS_DISPLAY_ROLLING_AVG_LABEL,
  FARM_DIAGNOSTICS_DISPLAY_YEAR_ON_YEAR_LABEL,
} from 'constants/uiConstants';
import React from 'react';

export interface TrendDisplayOptions {
  showYearOnYear: boolean;
  showRollingAvg: boolean;
  showMarkers: boolean;
}

export const DEFAULT_TREND_DISPLAY_OPTIONS: TrendDisplayOptions = {
  showYearOnYear: true,
  showRollingAvg: true,
  // Markers are opt-in — off by default so the charts aren't cluttered.
  showMarkers: false,
};

interface TrendDisplayOptionsControlProps {
  options: TrendDisplayOptions;
  onChange: (options: TrendDisplayOptions) => void;
}

/**
 * One shared control affecting every trend chart currently on screen (WUE
 * Trend / Financial Efficiency / Bio vs Financial) — rendered once, not
 * duplicated per chart, so all charts stay in visual sync. Management
 * practice markers default OFF (opt-in) since they clutter the chart by
 * default; year-on-year and rolling average both default ON, matching what
 * the charts already showed before this control existed.
 */
const TrendDisplayOptionsControl: React.FC<TrendDisplayOptionsControlProps> = ({
  options,
  onChange,
}) => (
  <div className="flex flex-wrap items-center gap-4">
    <span className="text-sm font-semibold text-charcoal">
      {FARM_DIAGNOSTICS_DISPLAY_OPTIONS_TITLE}
    </span>
    <Checkbox
      checked={options.showYearOnYear}
      onChange={(e) => onChange({ ...options, showYearOnYear: e.target.checked })}
    >
      {FARM_DIAGNOSTICS_DISPLAY_YEAR_ON_YEAR_LABEL}
    </Checkbox>
    <Checkbox
      checked={options.showRollingAvg}
      onChange={(e) => onChange({ ...options, showRollingAvg: e.target.checked })}
    >
      {FARM_DIAGNOSTICS_DISPLAY_ROLLING_AVG_LABEL}
    </Checkbox>
    <Checkbox
      checked={options.showMarkers}
      onChange={(e) => onChange({ ...options, showMarkers: e.target.checked })}
    >
      {FARM_DIAGNOSTICS_DISPLAY_MARKERS_LABEL}
    </Checkbox>
  </div>
);

export default TrendDisplayOptionsControl;
